<script>
  import Layout from '../components/Layout.svelte';
  import { _ } from 'svelte-i18n';
</script>

<Layout>
  {$_('notFound.text', { default: 'Sorry, that page could not be found.' })}
</Layout>
